export default "__VITE_ASSET__DJcMzKA2__"